import { profileVerified } from "assets";
import { Dialog, DialogContent, DialogTrigger } from "components/app/dialog/dialog";
import ImageUrlProfile from "components/app/image-url/ImageUrlProfile";
import { Button } from "components/ui/button";
import { ScrollArea } from "components/ui/scroll-area";

export default function DialogShowUserFollowing({ user }: { user: any }) {
  return (
    <Dialog>
      <DialogTrigger className="flex">
        <p className="mr-1">{user?.no_of_following}</p>
        <p>Following</p>
      </DialogTrigger>
      <DialogContent>
        <h1 className="text-center font-semibold">Following</h1>
        <ScrollArea className="h-96">
          {[...Array(20)].map((_, index) => {
            return (
              <div key={index} className="flex justify-between mb-4">
                <div>
                  <div className="flex items-center gap-1">
                    <ImageUrlProfile
                      isLinkProfile={true}
                      className="rounded-full object-cover border"
                      user={user}
                      // user={post?.user}
                      style={{ width: 40, height: 40 }}
                      alt="user"
                    />
                    <div className="flex flex-col items-start justify-center">
                      <div className="flex">
                        <p className="text-xs font-semibold line-clamp-1">{/* {post?.user?.name} */}This is my Name</p>
                        {/* {post?.user?.is_verified === "Yes" ? (
                                              <>
                                                <div className="flex items-center justify-center pt-0.5 ml-1">
                                                  <img
                                                    src={profileVerified}
                                                    style={{ width: 12, height: 12 }}
                                                    alt=""
                                                  />
                                                </div>
                                              </>
                                            ) : (
                                              <></>
                                            )} */}
                        <div className="flex items-center justify-center pt-0.5 ml-1">
                          <img
                            src={profileVerified}
                            style={{
                              width: 12,
                              height: 12,
                            }}
                            alt=""
                          />
                        </div>
                        <span className="text-xs ms-2">2 hours ago</span>
                      </div>
                      <p className="text-xs text-gray-600 line-clamp-1">
                        This is my bio
                        {/* {post?.user?.bio} */}
                      </p>
                    </div>
                  </div>
                </div>
                <div>
                  <Button variant="secondary">Friend</Button>
                </div>
              </div>
            );
          })}
        </ScrollArea>
      </DialogContent>
    </Dialog>
  );
}
